var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('agency-contest-beneficiaries-table'),_c('agency-d-a-c-codes'),_c('agency-contest-type-table'),_c('agency-contest-paragraphs-table')],1)}
var staticRenderFns = []

export { render, staticRenderFns }